import { IBrandOrder } from '../../indigofair/data/IBrandOrder';
import { IFaireMoney } from '../../indigofair/data/IFaireMoney';
import { IInvoice } from '../../indigofair/data/IInvoice';

export namespace ISelfServeBrandOrder {
  export type StateType =
    | 'STATE_UNKNOWN'
    | 'NEW'
    | 'UNFULFILLED'
    | 'SHIPPED'
    | 'DELIVERED'
    | 'CANCELED';

  export enum State {
    STATE_UNKNOWN = 'STATE_UNKNOWN',
    NEW = 'NEW',
    UNFULFILLED = 'UNFULFILLED',
    SHIPPED = 'SHIPPED',
    DELIVERED = 'DELIVERED',
    CANCELED = 'CANCELED',
  }

  /**
   * Return an instance of ISelfServeBrandOrder with the provided fields. Any field not
   * listed will be populated with an empty value (an empty array,
   * or undefined, whichever is valid for the type of the value.)
   */
  export const build = (
    partial?: Partial<ISelfServeBrandOrder>
  ): ISelfServeBrandOrder =>
    ({
      ...(partial ?? {}),
    } as ISelfServeBrandOrder);
}

export interface ISelfServeBrandOrder {
  /**
   * Summary of the brand order, e.g. `Total: $434.00 (6 items)`
   */
  summary_string: string | undefined;
  /**
   * Text of when the order has been placed, e.g. "Placed on Jul 15, 2022"
   */
  order_placed_string: string | undefined;
  /**
   * Long text of when the order has been placed, e.g. "Order #1E3D placed on Jul 15, 2022"
   */
  order_placed_long_string: string | undefined;
  /**
   * Summary of the brand commission, e.g. `Opening Order - 25%`
   */
  brand_commission_string: string | undefined;
  /**
   * Status of the brand order with the shipped/delivered/canceled/etc. date, i.e. `Delivered Jan 1, 2016`
   */
  status_string: string | undefined;
  brand_name: string | undefined;
  retailer_name: string | undefined;
  total_number_of_items: number | undefined;
  total_price: IFaireMoney | undefined;
  brand_order: IBrandOrder | undefined;
  /**
   * Customer-facing version of the order token to display to a retailer.
   * (e.g. if the `orderToken` is `o_a1b2c3`, this would be `"A1B2C3"`)
   */
  order_number: string | undefined;
  /**
   * Customer-facing version of the brand order token to display to a brand.
   * (e.g. if the `brandOrderToken` is `bo_z9y8x7`, this would be `"Z9Y8X7"`)
   */
  brand_order_number: string | undefined;
  free_duties_reason: keyof typeof IBrandOrder.FreeDutiesReason | undefined;
  /**
   * The state of the invoice for this brand order
   */
  invoice_state: keyof typeof IInvoice.State | undefined;
  state: keyof typeof ISelfServeBrandOrder.State | undefined;
  is_ship_with_faire: boolean | undefined;
}
